import PoleItem from '@/utils/pole-item';

//
// TODO
//
export class ItemSelected {
  constructor(type, item, from) {
    this.type = type;
    this.pole = item.pole;
    this.link = item.link;
    this.from = from;
  }

  static pole(pole, opts) {
    return pole
        ? new ItemSelected('pole', { pole }, opts?.from)
        : null;
  }

  static link(link, opts) {
    return link
        ? new ItemSelected('link', { link }, opts?.from)
        : null;
  }
}

export default ItemSelected;
